var _ArrowRight;
import React from "react";
import ArrowRight from "@crehana/compass.icons.outline/ArrowRight";
import { useCatalogEmptyStateContext } from "../context";
import { useCatalogEmptyStateTranslations } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Title = function Title() {
  var _useCatalogEmptyState = useCatalogEmptyStateContext(),
    catalogLink = _useCatalogEmptyState.catalogLink;
  var _useCatalogEmptyState2 = useCatalogEmptyStateTranslations(),
    t = _useCatalogEmptyState2.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-items-center tw-justify-between tw-pb-1.2 tw-mb-1.2",
    children: [/*#__PURE__*/_jsx("h1", {
      className: "tw-font-subtitle4",
      children: t('CATALOG_EMPTY_STATE_TITLE')
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-items-center",
      children: [/*#__PURE__*/_jsx("a", {
        className: "tw-text-primary-light-500 dark:tw-text-secondary-dark-500 tw-font-subtitle4",
        href: catalogLink,
        children: t('CATALOG_EMPTY_STATE_GO_TO_CATALOG')
      }), _ArrowRight || (_ArrowRight = /*#__PURE__*/_jsx(ArrowRight, {
        className: "tw-fill-current tw-text-primary-light-500 dark:tw-text-secondary-dark-500",
        size: 20
      }))]
    })]
  });
};
export default Title;